import { dom, library, config } from "@fortawesome/fontawesome-svg-core";

import {
    faChevronRight,
    faChevronDown,
    faMapPin,
    faPhoneAlt,
    faEnvelope,
    faSearch,
    faTimes as times2,
    faPrint,
    faSpinner,
    faPlayCircle,
    faMapMarkerAlt,
    faCheck,
    faInfoCircle,
    faExclamationCircle,
    faLongArrowAltDown,
    faTimes

} from "@fortawesome/free-solid-svg-icons";

/*
import {
    faCheck,
    faTimes,
    faInfoCircle,
    faExclamationCircle,
    faLongArrowAltDown
} from "@fortawesome/free-regular-svg-icons";
*/
// import {} from "@fortawesome/pro-light-svg-icons";

import {
    faInstagram,
    faTwitter,
    faLinkedin,
    faFacebook,
    faFacebookF,
    faYoutube
} from "@fortawesome/free-brands-svg-icons";

config.autoReplaceSvg = true;
config.observeMutations = true;
// config.searchPseudoElements = true;

library.add(
    faCheck,
    faTimes,
    faInfoCircle,
    faExclamationCircle,
    faChevronRight,
    faChevronDown,
    faInstagram,
    faTwitter,
    faLinkedin,
    faFacebook,
    faFacebookF,
    faYoutube,
    faMapPin,
    faPhoneAlt,
    faEnvelope,
    faSearch,
    times2,
    faPrint,
    faSpinner,
    faPlayCircle,
    faMapMarkerAlt,
    faLongArrowAltDown
);

dom.watch();
